const selectors = {
  readMoreBtn: document.querySelectorAll('[data-more-btn]')
};
  class TemplateCollectionJS {
    constructor() {
      this.readMore();
    }
    readMore(){
      selectors.readMoreBtn.forEach(element => {
        if(element){
          let contentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('.collection-txt-mobile').scrollHeight;
          let newContentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('.collection-txt-mobile').offsetHeight;

          if (contentBlockHeight == newContentBlockHeight){
            element.closest('[data-readmorecontainer]').querySelector('.collection-txt-mobile').style.height = 'auto';
            element.classList.add('d-none');
             element.classList.remove('d-inline-block');
          }
          element.addEventListener('click', (e)=> {
            e.preventDefault();
            let currentTarget = e.target;
            if(currentTarget.closest('[data-readmorecontainer]').classList.contains('open')){
              setTimeout(function () {
                currentTarget.closest('[data-readmorecontainer]').querySelector('.collection-txt-mobile').style.height = '';
              }, 1);
              currentTarget.closest('[data-readmorecontainer]').classList.remove('open');
              currentTarget.innerHTML = 'Show More';
            } else {
              currentTarget.closest('[data-readmorecontainer]').querySelector('.collection-txt-mobile').style.height = newContentBlockHeight + 'px';
              setTimeout(function () {
                currentTarget.closest('[data-readmorecontainer]').querySelector('.collection-txt-mobile').style.height = contentBlockHeight + 'px';
              }, 1);
              setTimeout(function () {
                currentTarget.closest('[data-readmorecontainer]').classList.add('open');
              }, 300);
              currentTarget.innerHTML = 'Show Less';
            }

          });
        }
      });
    }
}

typeof TemplateCollectionJS !== 'undefined' && new TemplateCollectionJS();
